import { useGraph } from "@features/builder/graph/graphAtoms"
import { useKeymap } from "@features/keymap/useKeymap"
import { LockOpen } from "@mui/icons-material"
import { Button, Grid, Typography } from "@mui/material"

type GraphLockedInfoProps = {
  onGraphUnlockClick: () => void
}

const GraphLockedInfo = (props: GraphLockedInfoProps) => {
  const { getKeymaps } = useKeymap()
  const keymap = getKeymaps().byId

  const { remotelyLockedBy, isRemotelyLockedBySomeoneElse } = useGraph()

  return (
    <Grid container justifyContent="center" sx={{ position: "absolute" }}>
      <Grid
        container
        item
        xs="auto"
        alignItems="center"
        direction="column"
        gap={1}
        sx={{ borderRadius: 3, zIndex: 5, backgroundColor: "rgba(128, 128, 128, .33)", p: 1 }}
      >
        <Grid item>
          <Typography variant="body2" sx={{ textAlign: "center", userSelect: "none" }}>
            Graph is currently in <strong>locked</strong> mode. <br />
            {keymap.get("toggle-lock")?.desc} or click the button below.
          </Typography>
        </Grid>

        <Grid item>
          <Button
            variant="contained"
            startIcon={<LockOpen />}
            onClick={props.onGraphUnlockClick}
            title={keymap.get("toggle-lock")?.desc}
            disabled={isRemotelyLockedBySomeoneElse}
          >
            Unlock
          </Button>
        </Grid>

        {isRemotelyLockedBySomeoneElse && (
          <Grid item>
            <Typography
              variant="body2"
              color="error"
              sx={{ textAlign: "center", userSelect: "none" }}
            >
              Graph is currently remotely locked by <strong>{remotelyLockedBy}</strong>.
              <br /> You cannot unlock it until the other user releases the lock.
            </Typography>
          </Grid>
        )}
      </Grid>
    </Grid>
  )
}

export default GraphLockedInfo
